import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';

export function DocumentsRequiredValidator(params: {
  minAmount: number;
  errorName: FORM_ERRORS;
}): ValidatorFn {
  return (fg: FormGroup): ValidationErrors | null => {
    const currAmount = Object.keys(fg.controls).length;
    if (currAmount < params.minAmount) {
      return { [params.errorName]: params.minAmount };
    } else {
      return null;
    }
  };
}
